import { Flex, theme } from 'antd'
import { ModeSwitch } from './ModeSwitch.tsx'
import { Threshold } from './Threshold.tsx'
import { ExportDropdown } from './ExportDropdown.tsx'
import { SettingsEditorPopup } from "./settings/SettingsEditorPopup.tsx"

const { useToken } = theme

export const DiagramActions = () => {
    const { token } = useToken()

    // Leaves room on the right for the zoom buttons (DiagramToolbar), so in a
    // narrow panel the controls wrap instead of running under them
    return (<Flex
        style={{ margin: token.marginXS, position: 'absolute', zIndex: 1, maxWidth: 'calc(100% - 150px)' }}
        gap={6}
        vertical
    >
        <Flex gap={6} align='center' wrap='wrap'>
            <SettingsEditorPopup />
            <ExportDropdown />
            <ModeSwitch />
        </Flex>
        <Threshold />
    </Flex>)
}
